import { parseJwt } from "./jwt";

export default class LoginData {
  constructor(token) {
    this.lastActivity = 0;
    this.token = token;
    this.setLastActivity();
    this.tokenData = this.getDataFromToken();
  }

  tokenDataEmpty() {
    return {
      user: {
        id: undefined,
        name: undefined,
        email: undefined,
        userLevel: "GUEST",
      },
      token: {
        token: undefined,
        valid: undefined,
        type: undefined
      }
    }
  }

  setLastActivity() {
    const currentDate = new Date();
    this.lastActivity = currentDate.getTime();
  }

  getLastActivity() {
    return this.lastActivity;
  }

  getDataFromToken() {
    let tokenData;
    if (!this.token || this.token === 'GUEST') {
      return this.tokenDataEmpty();
    }

    try {
      tokenData = parseJwt(this.token);
    } catch (error) {
      return this.tokenDataEmpty();
    }

    return {
      user: {
        id: tokenData.id,
        name: tokenData.name,
        email: tokenData.email,
        userLevel: tokenData.userLevel,
      },
      token: {
        token: this.token,
        valid: tokenData.valid,
        type: tokenData.type,
      },
    };
  }

  get() {
    return this.tokenData;
  }

  getToken() {
    return this.token;
  }

  getUserLevel() {
    return this.tokenData?.user?.userLevel;
  }

  getValidSeconds() {
    if (!this.token) {
      return 0;
    }

    const currentTime = Date.now();
    const validUntil = (this.tokenData.valid - currentTime) / 1000;
    return (validUntil < 2) ? 0 : validUntil;
  }
}
